<script lang="ts">
  import { page } from '$app/stores';
  import ErrorMessage from '$lib/components/ErrorMessage.svelte';
  // we don't want to use <svelte:window bind:online> here, because we only care about the online
  // state when the page first loads
  let online = typeof navigator !== 'undefined' ? navigator.onLine : true;
  let title: string = online ? `${$page.error?.title ?? 'Error'}` : 'You are offline';
  let message: string = online
    ? $page.error?.message ?? "We're sorry, something went wrong."
    : 'Reload the page once you have found the internet.';
</script>

<svelte:head>
  <title>{title}</title>
</svelte:head>

<section class="bg-background min-h-screen max-w-full">
  {#if $page.error}
    <div class="">
      <div class="w-fit mx-auto pt-16">
        <ErrorMessage code={$page.status} {title} {message} />
      </div>
    </div>
  {/if}
</section>
